import React, { FC, useContext } from 'react';
import { actionTargetsOrder, useOrdersAction } from '../Assistant/ordersActions';
import MoPNRDocket from './MoPNRDocket';
import MoPrint from './MoPrint';
import MoChangeRequest from './MoChangeRequest';
import MoVoucher from './MoVoucher';
import MoStatus from './MoStatus';
import MoCancelModal from './MoCancelModal';
import { MyOrder, OrderLog } from 'ts/shared/interfaces/MOResponse';
import MoSaveDocket from './MoSaveDocket';
import withErrorBoundary from '../../withErrorBoundary';
import MoCog from './MoCog';
import MoOpenLogs from './MoOpenLogs';
import MoCopyOrderJson from './MoCopyOrderJson';
import { MainContext } from 'contexts/MainContext';
interface MoActionsRowProps {
  myOrder: MyOrder;
  onUpdateMyOrder: (my: MyOrder) => void;
  onLoadLogs: (logs: OrderLog[]) => void;
  showCopyOrderJson?: boolean;
}

const MoActionsRow: FC<MoActionsRowProps> = (props) => {
  const { user } = useContext(MainContext);

  useOrdersAction(
    (action) =>
      !props.showCopyOrderJson &&
      action.action === 'copy-json' &&
      actionTargetsOrder(
        action,
        {
          segmentId: props.myOrder.orderRow.segmentId,
          orderId: props.myOrder.orderRow.orderId,
        },
        true,
      ),
    () => undefined,
  );

  return (
    <div className="mo-actions-row" data-assistant-target="orders-actions">
      <div className="mb-5 mt-5">
        <span className="mr-5">
          <MoPrint segment={props.myOrder.fullSegment} orderRow={props.myOrder.orderRow} />
        </span>
        <span className="mr-5">
          <MoPNRDocket
            segment={props.myOrder.fullSegment}
            orderRow={props.myOrder.orderRow}
            onSuccess={props.onUpdateMyOrder}
          />
        </span>
        <span className="mr-5">
          <MoChangeRequest
            segment={props.myOrder.fullSegment}
            orderRow={props.myOrder.orderRow}
            onSuccess={props.onUpdateMyOrder}
          />
        </span>
        <span>
          <MoVoucher
            segment={props.myOrder.fullSegment}
            myOrder={props.myOrder}
            onSuccess={props.onUpdateMyOrder}
          />
        </span>
        <span className="mr-5">
          <MoSaveDocket myOrder={props.myOrder} onSuccess={props.onUpdateMyOrder} />
        </span>
        <span className="mr-5">
          <MoCog
            myOrder={props.myOrder}
            onSuccess={props.onUpdateMyOrder}
            user={props.myOrder.user}
            dropdownProps={{ appendToBody: true, dropdownClassName: "c-dropdown-concat", appendToDirection: "top" }}

          />
        </span>
        <span className="mr-5 mo-mobile-btn mo-open-logs">
          <MoOpenLogs orderRow={props.myOrder.orderRow} onLoadLogs={props.onLoadLogs} />
        </span>
        <span className="mr-5 mo-mobile-btn">
          <MoStatus
            segment={props.myOrder.fullSegment}
            orderRow={props.myOrder.orderRow}
            onSuccess={props.onUpdateMyOrder}
          />
        </span>
        {props.showCopyOrderJson && (
          <span className="mr-5 mo-mobile-btn">
            <MoCopyOrderJson orderRow={props.myOrder.orderRow} />
          </span>
        )}
        {user?.branchId !== 5001 && (
          <span className="mr-5 mo-mobile-btn">
            <MoCancelModal orderRow={props.myOrder.orderRow} onSuccess={props.onUpdateMyOrder} />
          </span>
        )}
      </div>
    </div>
  );
};

export default withErrorBoundary(MoActionsRow, 'MoActionsRow');
